<template>
	<div class="layout-wrapper menu">
		<nav>
			<ul class="navigation">
				<li v-for="item in MENUS">
					<UIShLink
						:label="item.title"
						external
						:to="item.path"
						lg
						kind="gray"
						@click="$emit('close')"
					/>
				</li>
			</ul>
		</nav>

		<div class="contacts">
			<UIShLinkSocial
				icon="tg-social"
				:link="CONTACTS.tg.link"
				kind="white"
				md
			/>
			<UIShButton
				label="Заказать обратный звонок"
				md
				@click="toggleOrderPopup"
			/>
		</div>

		<OrderPopup v-if="dOrderPopup" @close="toggleOrderPopup" />
	</div>
</template>

<script setup lang="ts">
import { MENUS, CONTACTS } from '@/common/constants';

const dOrderPopup = ref(false);

function toggleOrderPopup() {
	dOrderPopup.value = !dOrderPopup.value;
}
</script>

<style lang="scss" scoped>
.menu {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	width: 100dvw;
	height: 100vh;
	height: 100dvh;
	padding-top: 4rem;
	background-color: inherit;
	padding-bottom: var(--layout-pad-y);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 0.556rem;
	background-color: var(--color-gray800);
}

.navigation {
	display: flex;
	flex-direction: column;
	gap: 1.111rem;
	padding: 1.111rem;
	border-radius: 0.667rem;
	border: 1px solid var(--color-gray700);
}

.contacts {
	display: flex;
	align-items: center;
	gap: 0.667rem;
	justify-content: space-between;
}
</style>
